<template>
  <div class="page">
    <Frame class="page-frame">
      <template v-slot:body>
        <div class="body">
          <ApplyDetail :detail="detail" />
          <ResumeDetail v-if="detail.status == 'finish'" />
          <div class="approval">
            <div class="title">审批流程</div>
            <desc-item :list="workflowListRecord" />
          </div>
          <FilterDialog
            v-show="isShowDialog"
            :is-footer="false"
            right-text="确定"
            left-text="取消"
            @right="onFilterDialogOk"
            @left="onFilterDialogCancle"
          >
            <ResumeForm ref="resumeform" />
          </FilterDialog>
        </div>
      </template>

      <template v-slot:footer>
        <div
          class="footer"
          v-if="
            (detail.status == 'underway' || detail.status == 'agree') &&
            userType != 'teacher'
          "
        >
          <div
            class="btn"
            v-if="detail.status != 'underway'"
            @click="showDialog"
          >
            销假
          </div>
          <div class="btn" v-else @click="revokeLeaveEvt">撤销</div>
        </div>

        <div
          class="footer teacher"
          v-if="detail.isNeedApprove && userType == 'teacher'"
        >
          <div class="btn refuse" @click="refuseEvt">拒绝</div>
          <div class="btn agree" @click="agreeEvt">同意</div>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "@/components/frame.vue";
import ApplyDetail from "./components/applyDetail.vue";
import ResumeDetail from "./components/resumeDetail.vue";
import FilterDialog from "@/components/filterDialog.vue";
import ResumeForm from "./components/resumeForm.vue";
import DescItem from "@/components/process-desc/components/desc-item.vue";

import { Toast, Dialog } from "vant";

import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "LeaveDetail",
  components: {
    Frame,
    ApplyDetail,
    ResumeDetail,
    FilterDialog,
    ResumeForm,
    DescItem
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const userType = computed(() => store.state.userType);

    const { id } = route.query;
    const detail = ref({
      approveCode: "",
      backTime: "",
      campusName: "",
      className: "",
      duration: "",
      endTime: "",
      fileList: [],
      gradeName: "",
      isBack: true,
      periodName: "",
      reason: "",
      startTime: "",
      status: "",
      statusName: "",
      studentName: "",
      typeName: ""
    });
    const applyInfo = params =>
      store.dispatch("studentLeave/applyInfo", params);
    const getApplyInfo = async () => {
      let params = {
        id: id
      };
      let r = await applyInfo(params);
      let { success, data } = r;
      if (!success) {
        Toast.fail(r.message);
        return;
      }
      detail.value = data;
      getWorkflowRecord();
    };
    getApplyInfo();

    const workflowListRecord = ref({});
    const workflowRecordInfo = params =>
      store.dispatch("studentLeave/workflowRecordInfo", params);
    const getWorkflowRecord = async () => {
      let params = {
        approveCode: detail.value.approveCode,
        bizType: "student_leave"
      };
      let r = await workflowRecordInfo(params);
      let { success } = r;
      if (!success) {
        Toast.fail(r.message);
        return;
      }
      let { applyHeadUrl, applyTime, applyUserName, detailList } = r.data || {};
      // 查询当前用户所在层级
      let level = -1;
      detailList.map(item => {
        if (level == -1 && !item.isFinish) {
          level = item.level;
        }
      });
      getApproverInfo({ approveCode: detail.value.approveCode, level });

      let applyUser = {
        approveTime: applyTime, //审批时间
        applyUser: "申请人", //审批(申请)人
        approveResult: "agree",
        userList: [
          {
            headUrl: applyHeadUrl, //用户头像
            userName: applyUserName //用户姓名
          }
        ] //人员列表
      };

      detailList.map(item => {
        item.applyUser = "审批人";
      });

      detailList.unshift(applyUser);
      workflowListRecord.value = detailList;
    };

    // 是否需要指定下一级审批人
    const isApproverData = ref({});
    const approverInfo = params =>
      store.dispatch("studentLeave/approverInfo", params);
    const getApproverInfo = async ({ approveCode, level }) => {
      let params = {
        approveCode,
        bizType: "student_leave",
        level
      };
      let r = await approverInfo(params);
      if (!r || !r.success) {
        Toast.fail(r.message);
        return;
      }
      isApproverData.value = r.data;
    };

    const resumeform = ref(null);
    const isShowDialog = ref(false);
    const showDialog = () => {
      isShowDialog.value = true;
    };
    const onFilterDialogOk = () => {
      let { callbackDateTime, isCallback } = resumeform.value;
      finishApplySubmit({
        applyId: id,
        backTime: callbackDateTime ? callbackDateTime + ":00" : "",
        isBack: isCallback
      });
    };
    const onFilterDialogCancle = () => {
      isShowDialog.value = false;
    };
    // 销假
    const finishApply = params =>
      store.dispatch("studentLeave/finishApply", params);
    const finishApplySubmit = async ({ applyId, backTime, isBack }) => {
      let params = {
        applyId,
        backTime,
        isBack
      };
      let r = await finishApply(params);
      if (!r || !r.success) {
        Toast.fail(r.message);
        // 关闭弹窗
        onFilterDialogCancle();
        return;
      }
      router.go(-1);
    };
    // 撤销
    const revokeApply = params =>
      store.dispatch("studentLeave/leaveRevokeApply", params);
    const revokeApplySubmit = async ({ id }) => {
      let params = {
        id
      };
      let r = await revokeApply(params);
      if (!r || !r.success) {
        Toast.fail(r.message);
      }
      router.go(-1);
    };
    const revokeLeaveEvt = () => {
      Dialog.confirm({
        title: "撤销",
        message: "确定要撤销请假！"
      })
        .then(() => {
          // on confirm
          revokeApplySubmit({ id });
        })
        .catch(() => {
          // on cancel
        });
    };

    // 教师端 拒绝
    const refuseEvt = () => {
      router.push({
        path: "/leaveRefuse",
        query: {
          applyId: id,
          approveCode: detail.value.approveCode,
          bizType: "student_leave"
        }
      });
    };

    // 教师端 同意
    const agreeEvt = () => {
      let { isChoose, chooseNumber, chooseRange, chooseUserList } =
        isApproverData.value || {};
      if (!isChoose) {
        // 不需要指定直接跳转同意理由页面
        router.push({
          path: "/leaveAgree",
          query: {
            applyId: id,
            approveCode: detail.value.approveCode,
            bizType: "student_leave"
          }
        });
      } else {
        let checkType = chooseNumber == "one" ? "single" : "multiple";
        let limit = chooseRange === "limited";
        let limitRange = chooseUserList;

        router.push({
          path: "/studentSelect",
          query: {
            moduleName: "processApprover",
            sourceType: "T",
            resType: "user",
            checkType,
            limit,
            limitRange,
            defaultList: []
          }
        });
      }
    };
    const persionSelectedPage = computed(() => store.state.persionSelectedPage);
    watch(
      persionSelectedPage,
      persionSelectedPage => {
        let { moduleName, data } = persionSelectedPage;
        if (moduleName == "processApprover") {
          data.map(user => {
            user.userName = user.name;
          });
          router.push({
            path: "/leaveAgree",
            query: {
              applyId: id,
              approveCode: detail.value.approveCode,
              bizType: "student_leave",
              chooseUserList: data
            }
          });
        }
      },
      {
        immediate: true
      }
    );
    // 测试数据
    // const detailList = ref([
    //   {
    //     approveTime: "2021.06.01 19:02", //审批时间
    //     applyUser: "申请人", //审批(申请)人
    //     approveMsg: "", // 会签内容
    //     approveResult: 2, //1未开始,进行中,2同意,3拒绝
    //     userList: [
    //       {
    //         headUrl: "https://dummyimage.com/44x44/000/fff", //用户头像
    //         userName: "test", //用户姓名
    //         approveResult: 2, //1:待审批,2:同意,3:拒绝
    //       },
    //     ], //人员列表
    //   },
    //   {
    //     approveTime: "2021.06.01 19:02", //审批时间
    //     applyUser: "审批人", //审批(申请)人
    //     isFinish: false, //当前层级是否已完成
    //     approveMsg: "(2人会签)", // 会签内容
    //     approveResult: 1, //1未开始,进行中,2同意,3拒绝
    //     userList: [
    //       {
    //         headUrl: "https://dummyimage.com/44x44/000/fff", //用户头像
    //         userName: "test", //用户姓名
    //         dealMsg: "",
    //         approveResult: 1, //1:待审批,2:同意,3:拒绝
    //       },
    //       {
    //         headUrl: "https://dummyimage.com/44x44/000/fff", //用户头像
    //         userName: "test", //用户姓名
    //         dealMsg: "",
    //         approveResult: 1, //1:待审批,2:同意,3:拒绝
    //       },
    //       {
    //         headUrl: "https://dummyimage.com/44x44/000/fff", //用户头像
    //         userName: "test", //用户姓名
    //         dealMsg: "",
    //         approveResult: 1, //1:待审批,2:同意,3:拒绝
    //       },
    //       {
    //         headUrl: "https://dummyimage.com/44x44/000/fff", //用户头像
    //         userName: "test", //用户姓名
    //         dealMsg: "同意",
    //         approveResult: 2, //1:待审批,2:同意,3:拒绝
    //       },
    //       {
    //         headUrl: "https://dummyimage.com/44x44/000/fff", //用户头像
    //         userName: "test", //用户姓名
    //         dealMsg: "同意",
    //         approveResult: 2, //1:待审批,2:同意,3:拒绝
    //       },
    //       {
    //         headUrl: "https://dummyimage.com/44x44/000/fff", //用户头像
    //         userName: "test", //用户姓名
    //         dealMsg: "",
    //         approveResult: 1, //1:待审批,2:同意,3:拒绝
    //       },
    //     ], //人员列表
    //   },
    //   {
    //     approveTime: "2021.06.01 19:02", //审批时间
    //     applyUser: "审批人", //审批(申请)人
    //     isFinish: false, //当前层级是否已完成
    //     approveMsg: "", // 会签内容
    //     approveResult: 3, //1未开始,进行中,2同意,3拒绝
    //     userList: [
    //       {
    //         headUrl: "https://dummyimage.com/44x44/000/fff", //用户头像
    //         userName: "test", //用户姓名
    //         approveResult: 3, //1:待审批,2:同意,3:拒绝
    //         dealMsg: "拒绝",
    //       },
    //     ], //人员列表
    //   },
    // ]);
    return {
      userType,
      detail,
      isShowDialog,
      resumeform,
      showDialog,
      onFilterDialogOk,
      onFilterDialogCancle,
      refuseEvt,
      agreeEvt,
      workflowListRecord,
      revokeLeaveEvt
    };
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
}
.page-frame {
  box-sizing: border-box;
  background-color: #f2f4f9;

  height: 100vh;
}
.body {
  padding: 15px;
}
.footer {
  box-sizing: border-box;
  padding: 6px 0;
  background-color: #fff;
  &.teacher {
    display: flex;
    .btn {
      width: 150px;
      &.agree {
        color: #fff;
        background: #4174fd;
      }
    }
  }
  .btn {
    width: 345px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #4174fd;
    border-radius: 18px;
    border: 1px solid #4174fd;
    margin: 6px auto;
  }
}
.approval {
  border-radius: 8px;
  background-color: #fff;
  .title {
    font-size: 15px;
    font-weight: 400;
    color: #333333;
    padding: 12px;
    margin: 12px auto;
  }
}
</style>
